(function () {
  'use strict';

  var DISCOUNT_KEY = 'zg_discount';
  var root = null;
  var overlay = null;
  var dialog = null;
  var form = null;
  var submitButton = null;
  var nameInput = null;
  var emailInput = null;
  var nameError = null;
  var emailError = null;
  var modelNode = null;
  var imageWrap = null;
  var imageNode = null;
  var webhookUrl = '';
  var enabled = false;
  var metaPixelLeadEnabled = false;
  var metaPixelLeadEvent = 'Lead';
  var metaPixelId = '';
  var metaPixelValidateEmail = true;
  var errorNameRequired = 'Please enter your first name.';
  var errorEmailRequired = 'Please enter your email address.';
  var errorEmailInvalid = 'Please enter a valid email address.';
  var pending = null;
  var focus = window.GhostModalFocus;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function getContactValues() {
    return {
      name: nameInput ? nameInput.value.trim() : '',
      email: emailInput ? emailInput.value.trim() : ''
    };
  }

  function getEmailValidationMessage(email) {
    if (!email) {
      return errorEmailRequired;
    }

    if (!isValidEmail(email)) {
      return errorEmailInvalid;
    }

    return '';
  }

  function isContactFormValid() {
    var values = getContactValues();
    return values.name.length > 0 && values.email.length > 0 && isValidEmail(values.email);
  }

  function setFieldError(input, errorNode, message) {
    if (!errorNode) return;

    if (message) {
      errorNode.textContent = message;
      errorNode.hidden = false;
      if (input) input.setAttribute('aria-invalid', 'true');
      return;
    }

    errorNode.textContent = '';
    errorNode.hidden = true;
    if (input) input.removeAttribute('aria-invalid');
  }

  function updateFormState(options) {
    var showErrors = Boolean(options && options.showErrors);
    var values = getContactValues();
    var valid = isContactFormValid();

    if (submitButton) {
      submitButton.disabled = !valid;
    }

    if (showErrors) {
      setFieldError(nameInput, nameError, values.name ? '' : errorNameRequired);
      setFieldError(emailInput, emailError, getEmailValidationMessage(values.email));
    }

    return valid;
  }

  function resetFormValidation() {
    setFieldError(nameInput, nameError, '');
    setFieldError(emailInput, emailError, '');
    updateFormState({ showErrors: false });
  }

  function bindFormValidation() {
    if (!form) return;

    function handleInput() {
      var values = getContactValues();

      if (values.name) {
        setFieldError(nameInput, nameError, '');
      }

      if (values.email && isValidEmail(values.email)) {
        setFieldError(emailInput, emailError, '');
      }

      updateFormState({ showErrors: false });
    }

    function handleNameBlur() {
      var values = getContactValues();
      if (!values.name) {
        setFieldError(nameInput, nameError, errorNameRequired);
      }
    }

    function handleEmailBlur() {
      var values = getContactValues();
      setFieldError(emailInput, emailError, getEmailValidationMessage(values.email));
    }

    if (nameInput) {
      nameInput.addEventListener('input', handleInput);
      nameInput.addEventListener('blur', handleNameBlur);
    }

    if (emailInput) {
      emailInput.addEventListener('input', handleInput);
      emailInput.addEventListener('blur', handleEmailBlur);
    }
  }

  function loadMetaPixelScript(callback) {
    if (typeof window.fbq === 'function') {
      callback();
      return;
    }

    if (!metaPixelId) {
      callback();
      return;
    }

    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', metaPixelId);
    callback();
  }

  function trackMetaLead(callback) {
    if (!metaPixelLeadEnabled || !isContactFormValid()) {
      if (callback) callback();
      return;
    }

    var eventName = metaPixelLeadEvent || 'Lead';

    loadMetaPixelScript(function () {
      if (typeof window.fbq !== 'function') {
        if (callback) callback();
        return;
      }

      if (metaPixelId) {
        window.fbq('trackSingle', metaPixelId, eventName);
      } else {
        window.fbq('track', eventName);
      }

      if (callback) {
        window.setTimeout(callback, 250);
      }
    });
  }

  function readDiscount() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('discount');

    if (fromUrl) {
      sessionStorage.setItem(DISCOUNT_KEY, fromUrl);
      return fromUrl;
    }

    return sessionStorage.getItem(DISCOUNT_KEY);
  }

  function getDiscountCodesFromCart(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) {
      return [];
    }

    return cart.discount_codes
      .filter(function (entry) {
        return entry && entry.applicable !== false && entry.code;
      })
      .map(function (entry) {
        return String(entry.code).trim();
      });
  }

  function resolveCheckoutDiscount(cart) {
    var cartCodes = getDiscountCodesFromCart(cart);
    if (cartCodes.length) {
      return cartCodes.join(',');
    }

    return readDiscount() || '';
  }

  function appendDiscount(url) {
    var code = readDiscount();
    if (!code) return url;

    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'discount=' + encodeURIComponent(code);
  }

  function buildCartPath(items) {
    if (!items || !items.length) return '';

    return items
      .map(function (item) {
        return String(item.variant_id) + ':' + String(item.quantity || 1);
      })
      .join(',');
  }

  function cartHasSellingPlans(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      return !!(item && item.selling_plan_allocation);
    });
  }

  function buildCheckoutUrl(baseUrl, name, email, cart) {
    var params = new URLSearchParams();

    if (email) {
      params.set('checkout[email]', email);
    }
    if (name) {
      params.set('checkout[shipping_address][first_name]', name);
    }

    var code = resolveCheckoutDiscount(cart);
    if (code) {
      params.set('discount', code);
      try {
        sessionStorage.setItem(DISCOUNT_KEY, code);
      } catch (storageError) {
        /* ignore */
      }
    }

    var query = params.toString();
    return query ? '/checkout?' + query : '/checkout';
  }

  function parseCartPermalink(url) {
    var value = String(url || '').split('?')[0];
    var cartIndex = value.indexOf('/cart/');

    if (cartIndex === -1) {
      return [];
    }

    var segment = value.slice(cartIndex + '/cart/'.length);
    if (!segment || segment === 'add' || segment === 'change' || segment === 'clear') {
      return [];
    }

    return segment.split(',').map(function (part) {
      var bits = part.trim().split(':');
      return {
        id: bits[0],
        quantity: parseInt(bits[1] || '1', 10) || 1
      };
    }).filter(function (item) {
      return item.id;
    });
  }

  function resolveWebhookUrl(override) {
    if (override) {
      return override;
    }

    if (webhookUrl) {
      return webhookUrl;
    }

    if (root) {
      return root.getAttribute('data-webhook-url') || '';
    }

    return '';
  }

  function addItemsToCart(items) {
    if (!items || !items.length) {
      return Promise.resolve(null);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items.map(function (item) {
          var payload = {
            id: parseInt(item.id, 10),
            quantity: item.quantity || 1
          };
          if (item.selling_plan) {
            payload.selling_plan = parseInt(item.selling_plan, 10);
          }
          return payload;
        })
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add to cart.');
        }
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function ensurePendingCartItems() {
    if (!pending) {
      return Promise.resolve(null);
    }

    var items = [];

    if (pending.variantId) {
      items.push({
        id: pending.variantId,
        quantity: pending.quantity || 1
      });
    } else {
      items = parseCartPermalink(pending.checkoutUrl);
    }

    if (!items.length) {
      return Promise.resolve(null);
    }

    return addItemsToCart(items);
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) {
      return window.location.protocol + url;
    }
    return url;
  }

  function setModalImage(imageUrl, altText) {
    if (!imageWrap || !imageNode) return;

    if (imageUrl) {
      imageNode.src = imageUrl;
      imageNode.alt = altText || '';
      imageWrap.hidden = false;
    } else {
      imageNode.removeAttribute('src');
      imageNode.alt = '';
      imageWrap.hidden = true;
    }
  }

  function pickCartHighlight(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return { imageUrl: '', modelName: '' };
    }

    var picked = cart.items[0];

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].image) {
        picked = cart.items[i];
        break;
      }
    }

    return {
      imageUrl: picked.image || '',
      modelName: formatProductLabel(picked)
    };
  }

  function loadModalImageFromCart(fallbackModelName) {
    return fetchCartSnapshot().then(function (cart) {
      var picked = pickCartHighlight(cart);

      if (picked.imageUrl) {
        setModalImage(picked.imageUrl, picked.modelName || fallbackModelName || '');
      }

      return cart;
    });
  }

  function fetchCartSnapshot() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load cart.');
        }
        return response.json();
      })
      .then(function (cart) {
        return {
          item_count: cart.item_count || 0,
          total_price: cart.total_price || 0,
          items: (cart.items || []).map(function (item) {
            return {
              title: item.product_title || item.title || '',
              variant_title: item.variant_title || '',
              quantity: item.quantity || 0,
              price: item.price || 0,
              line_price: item.line_price || 0,
              variant_id: item.variant_id || null,
              product_id: item.product_id || null,
              sku: item.sku || '',
              url: item.url ? window.location.origin + item.url : '',
              image: normalizeImageUrl(item.image || (item.featured_image && item.featured_image.url) || '')
            };
          })
        };
      })
      .catch(function () {
        return {
          item_count: 0,
          total_price: 0,
          items: []
        };
      });
  }

  function formatProductLabel(item) {
    var title = item.title || '';
    var variant = item.variant_title || '';
    var qty = item.quantity || 1;
    var label = title;

    if (variant && variant !== 'Default Title') {
      label += ' - ' + variant;
    }

    label += ' (Qty: ' + qty + ')';
    return label;
  }

  function buildProductsString(items) {
    return (items || [])
      .map(formatProductLabel)
      .filter(Boolean)
      .join(', ');
  }

  function sendWebhook(payload) {
    var targetUrl = resolveWebhookUrl(payload.webhookUrl);
    if (!targetUrl) {
      return Promise.resolve(false);
    }

    var cart = payload.cart || { item_count: 0, total_price: 0, items: [] };
    var products = buildProductsString(cart.items);
    var body = {
      name: payload.name,
      email: payload.email,
      phone_model: payload.modelName || '',
      type: payload.type || 'purchase',
      source: payload.source || 'checkout_capture',
      page_url: payload.pageUrl || window.location.href,
      cart_item_count: cart.item_count,
      cart_total: cart.total_price,
      products: products
    };

    return fetch(targetUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body),
      keepalive: true
    })
      .then(function (response) {
        return response.text().then(function () {
          return response.ok;
        });
      })
      .catch(function () {
        return false;
      });
  }

  function closeModal() {
    if (!overlay) return;

    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    if (root) root.hidden = false;
    document.documentElement.classList.remove('ghost-checkout-capture-open');
    pending = null;

    if (form) form.reset();
    resetFormValidation();
    if (focus) focus.restoreFocus();
  }

  function cartHasItems(cart) {
    return Boolean(
      cart &&
        Number(cart.item_count || 0) > 0 &&
        Array.isArray(cart.items) &&
        cart.items.length > 0
    );
  }

  function openModal(options) {
    if (!enabled || !overlay || !options || !options.checkoutUrl) return false;

    if (!options.variantId && options.requireCart !== false && options.cart && !cartHasItems(options.cart)) {
      return false;
    }

    pending = {
      checkoutUrl: options.checkoutUrl,
      modelName: options.modelName || '',
      imageUrl: options.imageUrl || '',
      type: options.type || 'purchase',
      source: options.source || 'checkout_capture',
      pageUrl: options.pageUrl || window.location.href,
      webhookUrl: resolveWebhookUrl(options.webhookUrl),
      variantId: options.variantId || '',
      quantity: options.quantity || 1
    };

    if (modelNode) {
      modelNode.textContent = pending.modelName ? ' ' + pending.modelName : '';
    }

    if (pending.imageUrl) {
      setModalImage(pending.imageUrl, pending.modelName);
    } else {
      setModalImage('', '');
      loadModalImageFromCart(pending.modelName);
    }

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    if (root) root.hidden = false;
    document.documentElement.classList.add('ghost-checkout-capture-open');

    if (focus) {
      focus.rememberFocus();
      focus.focusInitial(dialog, '[data-checkout-capture-close]');
    }

    if (form) form.reset();
    resetFormValidation();

    return true;
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!pending || !form) return;

    if (!updateFormState({ showErrors: true })) {
      var invalidValues = getContactValues();
      if (!invalidValues.name && nameInput) {
        nameInput.focus();
      } else if (emailInput) {
        emailInput.focus();
      }
      return;
    }

    var values = getContactValues();
    var name = values.name;
    var email = values.email;

    if (submitButton) submitButton.disabled = true;

    var pendingSnapshot = pending;

    ensurePendingCartItems()
      .then(function () {
        return fetchCartSnapshot();
      })
      .then(function (cart) {
        if (!pendingSnapshot) {
          return;
        }

        var checkoutTarget = buildCheckoutUrl(
          pendingSnapshot.checkoutUrl,
          name,
          email,
          cart
        );

        return sendWebhook({
          name: name,
          email: email,
          modelName: pendingSnapshot.modelName,
          type: pendingSnapshot.type,
          source: pendingSnapshot.source,
          pageUrl: pendingSnapshot.pageUrl || window.location.href,
          webhookUrl: pendingSnapshot.webhookUrl,
          cart: cart
        }).then(function () {
          trackMetaLead(function () {
            window.location.href = checkoutTarget;
          });
        });
      })
      .catch(function () {
        updateFormState({ showErrors: true });
      });
  }

  function openCheckoutFromTrigger(checkoutLink) {
    if (!checkoutLink) return;

    var variantId = checkoutLink.getAttribute('data-variant-id') || '';
    var checkoutUrl =
      checkoutLink.getAttribute('href') ||
      checkoutLink.getAttribute('data-checkout-url') ||
      '/checkout';
    var payload = {
      checkoutUrl: checkoutUrl,
      modelName: checkoutLink.getAttribute('data-checkout-model') || 'Cart checkout',
      source: checkoutLink.getAttribute('data-checkout-source') || 'cart',
      pageUrl: window.location.href,
      imageUrl: checkoutLink.getAttribute('data-image-url') || '',
      variantId: variantId,
      quantity: parseInt(checkoutLink.getAttribute('data-quantity') || '1', 10) || 1
    };

    if (variantId) {
      openModal(payload);
      return;
    }

    if (checkoutLink.disabled || checkoutLink.hidden || checkoutLink.getAttribute('aria-hidden') === 'true') {
      return;
    }

    fetchCartSnapshot().then(function (cart) {
      if (!cartHasItems(cart)) {
        return;
      }

      payload.cart = cart;
      openModal(payload);
    });
  }

  function bindCheckoutTriggers() {
    var closeButtons = root ? root.querySelectorAll('[data-checkout-capture-close]') : [];

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('click', function (event) {
      var checkoutLink = event.target.closest('[data-ghost-cart-checkout], [data-ghost-checkout-trigger]');
      if (checkoutLink) {
        event.preventDefault();
        event.stopPropagation();
        openCheckoutFromTrigger(checkoutLink);
        return;
      }

      if (event.target.closest('[data-checkout-capture-close]')) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (overlay && event.target === overlay) {
        closeModal();
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var formNode = event.target;
      if (!formNode || formNode.tagName !== 'FORM') return;

      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      event.preventDefault();

      fetchCartSnapshot().then(function (cart) {
        if (!cartHasItems(cart)) {
          return;
        }

        openModal({
          checkoutUrl: '/checkout',
          modelName: 'Cart checkout',
          source: 'cart_page',
          pageUrl: window.location.href,
          cart: cart
        });
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay && !overlay.hidden) {
        closeModal();
        return;
      }

      if (event.key === 'Tab' && overlay && !overlay.hidden && focus && dialog) {
        focus.trapTab(event, dialog);
      }
    });
  }

  function init() {
    root = document.querySelector('[data-ghost-checkout-capture]');
    if (!root || root.dataset.checkoutCaptureInit === 'true') return;

    root.dataset.checkoutCaptureInit = 'true';
    enabled = root.getAttribute('data-enabled') === 'true';
    webhookUrl = root.getAttribute('data-webhook-url') || '';
    metaPixelLeadEnabled = root.getAttribute('data-meta-pixel-lead-enabled') === 'true';
    metaPixelLeadEvent = root.getAttribute('data-meta-pixel-lead-event') || 'Lead';
    metaPixelId = root.getAttribute('data-meta-pixel-id') || '';
    metaPixelValidateEmail = root.getAttribute('data-meta-pixel-validate-email') !== 'false';
    errorNameRequired = root.getAttribute('data-error-name-required') || errorNameRequired;
    errorEmailRequired = root.getAttribute('data-error-email-required') || errorEmailRequired;
    errorEmailInvalid = root.getAttribute('data-error-email-invalid') || errorEmailInvalid;
    overlay = root.querySelector('[data-checkout-capture-overlay]');
    dialog = root.querySelector('[data-checkout-capture-dialog]');
    form = root.querySelector('[data-checkout-capture-form]');
    submitButton = root.querySelector('[data-checkout-capture-submit]');
    nameInput = root.querySelector('[data-checkout-capture-name]');
    emailInput = root.querySelector('[data-checkout-capture-email]');
    nameError = root.querySelector('[data-checkout-capture-name-error]');
    emailError = root.querySelector('[data-checkout-capture-email-error]');
    modelNode = root.querySelector('[data-checkout-capture-model]');
    imageWrap = root.querySelector('[data-checkout-capture-image-wrap]');
    imageNode = root.querySelector('[data-checkout-capture-image]');

    if (!enabled || !overlay || !form) return;

    form.addEventListener('submit', handleSubmit);
    bindFormValidation();
    resetFormValidation();
    bindCheckoutTriggers();

    window.GhostCheckoutCapture = {
      open: openModal,
      close: closeModal,
      buildCheckoutUrl: buildCheckoutUrl,
      getWebhookUrl: function () {
        return resolveWebhookUrl('');
      },
      isEnabled: function () {
        return enabled;
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
